export default {
  hasMultipleProjects: state => {
    return (
      state.brainedUserDetails &&
      state.brainedUserDetails.projects &&
      state.brainedUserDetails.projects.length > 1
    );
  },
  projects: state => {
    return state.brainedUserDetails && state.brainedUserDetails.projects;
  },
  isBusinessAnalyst: state => {
    return state.brainedUserDetails && state.brainedUserDetails.role === "ba";
  },
  isClient: state => {
    return (
      state.brainedUserDetails && state.brainedUserDetails.role === "client"
    );
  },
  isUX: state => {
    return state.brainedUserDetails && state.brainedUserDetails.role === "ux";
  }
};
